import { useState } from "react";
import { Button, Segment } from "semantic-ui-react";

export const RettmobilInit = ({ onAccepted }: { onAccepted: () => void }) => {
  const [accepted, setAccepted] = useState(false);
  const [showDataProtection, setShowDataProtection] = useState(false);

  return accepted ? null : (
    <>
      <Segment>
        <div className="space-y-2">
          <h4 className="text-lg font-bold">Rettmobil 2025</h4>

          <p>
            Vielen Dank für Ihre Bereitschaft, das von Ihnen wahrgenommene
            Bildungsangebot auf der Rettmobil 2025 zu evaluieren. Diese kurze
            Evaluation dient dem Zweck, den lehrenden Personen eine Rückmeldung
            über deren Bildungsangebot zu geben. Dieses Evaluationsangebot wird
            von der FeuerwehrAgentur im Auftrag der Kongressorganisation
            durchgeführt.
          </p>

          <p>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowDataProtection(!showDataProtection);
              }}
              className="text-blue-600 hover:text-blue-800 underline"
            >
              {showDataProtection
                ? "Datenschutzinformationen ausblenden"
                : "Datenschutzinformationen anzeigen"}
            </a>
          </p>
        </div>
      </Segment>

      {showDataProtection && (
        <Segment>
          <div className="space-y-2 mb-4">
            <h4 className="text-lg font-bold">Information zum Datenschutz</h4>

            <p>
              <strong>1.)</strong> Diese Umfrage dient dem Zweck, die
              Zufriedenheit der Teilnehmenden am Fortbildungsprogramm der
              Rettmobil 2025 zu erfassen.
            </p>

            <p>
              <strong>2.)</strong> Die Auswertung der Daten erfolgt
              anonymisiert.
            </p>

            <p>
              <strong>3.)</strong> Die Daten werden digital erfasst. Nach
              Bearbeitung der Befragung werden die Daten dieser Umfrage offline
              in einem Sicherheitsschrank als Datenträger bis zum Ablauf der
              Aufbewahrungsfrist gelagert. Diese beträgt derzeit 6 Jahre und
              endet am 31.12. des sechsten Folgejahres der Befragung.
            </p>

            <p>
              <strong>4.)</strong> Ihre Teilnahme an der Umfrage ist freiwillig.
              Sie können die Befragung hier beenden. Sofern Sie fortfahren,
              willigen Sie in die Erfassung, Verarbeitung und Auswertung Ihrer
              Daten im oben genannten Umfang ein. Sie müssen Fragen nicht
              beantworten, wenn Sie dies nicht möchten. Sie können Fragen
              überspringen und die Umfrage jederzeit beenden.
            </p>

            <p>
              <strong>Verarbeiter Ihrer Daten ist</strong>
              <br />
              Dr. Ruhrmann und Kollegen UG
              <br />
              Hauffstraße 39, 35398 Gießen
              <br />
              Vertreten durch den Geschäftsführer Martin Lutz
            </p>

            <p>
              <strong>Datenschutzbeauftragte ist</strong>
              <br />
              Dr. Sophie Ruhrmann
              <br />
              datenschutz@ruhrmann-kollegen.de
              <br />
              Dr. Ruhrmann und Kollegen UG
              <br />
              Hauffstraße 39, 35398 Gießen
            </p>
          </div>
        </Segment>
      )}

      <Button
        positive
        onClick={() => {
          setAccepted(true);
          onAccepted();
        }}
      >
        Akzeptieren und starten
      </Button>
    </>
  );
};
